module.exports = __webpack_public_path__ + "img/Jump Casting92.fb92805c.jpg";